/**
 * Determines if a feature is turned on in the build manifest
 * @param feature name of the feature (favorites, hompeage, category, etc).  See manifest.json
 * @return True if the feature is active
 */
export function isFeatureEnabled(feature) {
    return window.envVars.features.indexOf(feature) >= 0;
}
